import { Component } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { EMPTY, Observable, of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { NeedaFileService } from "../../needa-file-service";
import { Invoice } from "../invoice";
import { InvoiceService } from "../invoice-service";

@Component({
  templateUrl: './invoice-needa.component.html'
})
export class InvoiceNeedaComponent {
  public invoice!: Invoice;
  public needaFile = "";

  constructor(
    private invoiceService: InvoiceService,
    private needaFileService: NeedaFileService,
    private router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.paramMap.pipe(
      switchMap(paramMap => this.getInvoiceId(paramMap).pipe(
        switchMap(invoiceId => this.invoiceService.findById(invoiceId)),
        tap(invoice => this.invoice = invoice),
        switchMap(invoice => this.getNeedaFileName(paramMap)),
        switchMap(needaFileName => this.needaFileService.getNeedaFileContent(needaFileName)),
        tap(needaFile => this.needaFile = needaFile)))
    ).subscribe();
  }

  public getNeedaFile(fileName: string): Observable<string> {
    return this.needaFileService.getNeedaFileContent(fileName);
  }

  public getInvoiceId(paramMap: ParamMap): Observable<string> {
    var invoiceId = (paramMap.get("invoice") || "");

    if (invoiceId == "") {
      this.router.navigateByUrl("/404");

      return EMPTY;
    }

    return of(invoiceId);
  }

  public getNeedaFileName(paramMap: ParamMap): Observable<string> {
    var needaFileName = (paramMap.get("needaFileName") || "");

    if (needaFileName == "") {
      this.router.navigateByUrl("/404");

      return EMPTY;
    }

    return of(needaFileName);
  }
}